<div id="dialogHeader" class="dialogHeaderContainer">

  <!-- Die Datenbox soll nur angezeigt werden, wenn sie auch Inhalt hat. Die Implementierung der
  Erkennung folgt https://stackoverflow.com/questions/38692881/how-to-check-whether-ng-content-exists
  -->
  <div id="dataBox" class="box_noheader_bg_yellow dataBox" #dataBox [hidden]="!showDataBox">
    <ng-content select="[dataBox]"></ng-content>
  </div>

  <div class="elementsLeftContainer"  appScrollwithme>
  
    <!-- kundenspezifisches Speichern -->
    @if (showCustomButton) {
      <button default="false" (click)="onCustomEvent($event)" name="dialogHeaderButton"
        hisImage="{{customButtonImage}}" class="{{customButtonClass}}" (blur)="onBlur()">
        <span>{{customButtonLabel | hisUi}}</span>
      </button>
    }
    <!-- Entwurf speichern -->
    @if (showDraftSaveButton) {
      <button default="false" (click)="onSaveDraft($event)" (blur)="onBlur()" name="dialogHeaderButton"><span>{{'common.saveDraft' | hisUi}}</span></button>
    }
    <!-- Entwurf loeschen -->
    @if (showDraftDeleteButton) {
      <button default="false" (click)="onDeleteDraft($event)" (blur)="onBlur()" name="dialogHeaderButton"><span>{{'common.deleteDraft' | hisUi}}</span></button>
    }
    <!-- Speichern -->
    @if (showSaveButton) {
      <button default="true" (click)="onSave($event)" (blur)="onBlur()" name="dialogHeaderButton"><span>{{'common.save' | hisUi}}</span></button>
    }
    <!-- Speichern und Zurück -->
    @if (showSaveAndBackButton) {
      <button default="false" (click)="onSaveAndBack($event)" (blur)="onBlur()" name="dialogHeaderButton"><span>{{'de.his.javang.saveAndGoBack' | hisUi}}</span></button>
    }
    <!-- Eingaben zurücksetzen -->
    @if (showResetButton) {
      <button (click)="onResetInputs($event)" (blur)="onBlur()" name="dialogHeaderButton"><span>{{'common.reset' | hisUi}}</span></button>
    }
    <!-- Wenn es einen Weg zurück zur Suche geben soll (showSearchButton = "true"),
    dann wird ein Button "Zurück zum Suchergebnis" angezeigt sofern es schon eine Ergebnisseite gab,
    ansonsten ein Button "Zurück zur Suchseite". -->
    @if (showSearchButton && hasPreviousSearchResultPage()) {
      <button (click)="backToSearchResult()" (blur)="onBlur()" name="dialogHeaderButton"><span>{{'common.backToSearchResult' | hisUi}}</span></button>
    }
    @if (showSearchButton && !hasPreviousSearchResultPage() && hasPreviousSearchPage()) {
      <button (click)="backToSearch()" (blur)="onBlur()" name="dialogHeaderButton"><span>{{'common.backToSearchPage' | hisUi}}</span></button>
    }
    <!-- Zurück zur vorherigen Seite -->
    @if (showBackButton && hasBackUrl()) {
      <button (click)="back()" (blur)="onBlur()" name="dialogHeaderButton"><span>{{'common.back' | hisUi}}</span></button>
    }
    @if (showNewSearchButton && hasNewSearchUrl()) {
      <button class="newSearchButton" type="submit" iconPos="left" (click)="onNewSearch()">
        <span>{{'de.his.javang.newsearch'|hisUi}}</span>
      </button>
    }
    @if (showChangeSearchButton && hasChangeSearchUrl()) {
      <button class="changeSearchButton" type="submit" iconPos="left" (click)="onChangeSearch()">
        <span>{{'de.his.javang.changesearch'|hisUi}}</span>
      </button>
    }
    <!-- Anwendungsspezifische Buttons -->
    <ng-content select="[customButtons]"></ng-content>

    @if (renderPaginator) {
      <his-dialog-header-paginator (nextElement)="onPaginatorNextElement($event)"
                                  (previousElement)="onPaginatorPreviousElement($event)"
                                  [elements]="paginatorElements"
                                  [initialIndex]="paginatorIndex"/>
    }
  </div>

<!-- Job -->


    <div class="elementsRightContainer">
      <ng-content select="[elementsRight]"></ng-content>
    </div>
  </div>
  <div class="clearer"></div>
